<template>
  <div>
    <div
      class="bg-secondary-3 border-radius--light border--top mt-3 rounded border-left--color-secondary-12 border-top--color-secondary-12"
    >
      <div class="parent-padding-container">
        <visit-registry-form
          ref="visitRegistryFormRef"
          :compensatory-request-id="data.compensatoryRequestId"
          :contract-schedule="data.contractSchedule"
          :contract-specialists="contractSpecialists"
          :contract-start-date="data.contractStartDate"
          :default-specialist-id="defaultSpecialistId"
          :discipline-type-id="data.disciplineTypeId"
          :fee-schedule-cpt-options="feeScheduleCptOptions"
          :includes-transportation="showRequiredTransportationField"
          :is-compensatory-request="data.isCompensatoryRequest"
          :is-extended-academic-year="data.isExtendedAcademicYear"
          :is-therapy-a-b-a="isTherapyABA"
          :request-service-type-id="requestServiceTypeId"
          :selected-period="selectedPeriod"
          :service-duration="data.duration"
          :student-center-id="data.studentCenterId"
          :therapy-compensatory-info="therapyCompensatoryInfo"
          :visit-absence-reasons="visitAbsenceReasons"
          :visit-types="visitTypes"
          :visits-valid-for-reposition="visitsValidForReposition"
          @is-invalid-model="invalidModelHandler"
          @is-valid-model="validModelHandler"
          @on-save="(payload) => this.$emit('on-save', payload)"
        />
      </div>
    </div>

    <div
      v-if="validations && validations.length"
      class="visit-error-container visit-error-container-mt"
    >
      <error
        v-for="(error, errorIndex) in validations"
        :key="`validation-container-visit` + errorIndex"
        :message="error"
        variant="no-border"
      />
    </div>
  </div>
</template>

<script>
import VisitRegistryForm from './VisitRegistryForm.vue';
import Error from 'custom-error';

export default {
  name: 'VisitRegistryAddVue',
  components: {
    VisitRegistryForm,
    Error,
  },
  props: {
    isTherapyABA: {
      type: Boolean,
      default: () => false,
    },
    data: {
      type: Object,
      default: () => {},
    },
    contractSpecialists: {
      type: Array,
      default: () => [],
    },
    visitTypes: {
      type: Array,
      default: () => [],
    },
    visitsValidForReposition: {
      type: Array,
      default: () => [],
    },
    defaultSpecialistId: {
      type: Number,
      default: 0,
    },
    requestServiceTypeId: {
      type: Number,
      default: 0,
    },
    visitAbsenceReasons: {
      type: Array,
      default: () => [],
    },
    feeScheduleCptOptions: {
      type: Array,
      default: () => [],
    },
    selectedPeriod: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    validations: [],
  }),
  computed: {
    therapyCompensatoryInfo() {
      return {
        isTherapyCompensatory: this.data.isTherapyCompensatory,
        therapyCompensatoryBalance: this.data.therapyCompensatoryBalance,
        studentSieId: this.data.studentSieId,
        canEditCpt: this.data.canEditCpt,
      };
    },
    showRequiredTransportationField() {
      return this.data.includesTransportation;
    },
  },
  methods: {
    invalidModelHandler(validations) {
      this.validations = validations;
    },
    validModelHandler(validations) {
      this.validations = validations;
    },
    cleanVisitRegistryForm() {
      const visitRegistryRef = this.$refs.visitRegistryFormRef;
      visitRegistryRef.cleanModel();
      this.validations = [];
    },
    clearSpecialistDropdown() {
      if (this.$refs.visitRegistryFormRef) {
        this.$refs.visitRegistryFormRef.clearSpecialistDropdown();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.visit-error-container {
  background: #fae7e7;
  padding: 10px;
  border-radius: 0px 0px 5px 5px;
  margin-top: -16px;
  margin-bottom: 20px;
}

.visit-error-container-mt {
  margin-top: 0.01rem !important;
}

.parent-padding-container {
  padding: 15px 20px 15px 20px;
}
</style>
